import { StateCreator } from "zustand";

import { VendState } from ".";

export type TelemetrySlice = {
  machineTelemetry: VendState["machineTelemetry"];
};

export const createTelemetrySlice: StateCreator<
  VendState,
  [],
  [],
  TelemetrySlice
> = () => ({
  machineTelemetry: {},
});
